<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    :title="$t('model.paymentAccount')"
    resource="payment_accounts"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../admin_grapes/payment_accounts.js';

const TexRate = {
  functional: true,
  render(h, context) {
    const { props: { value }, listeners } = context;
    // 显示百分比
    const percent = (Number(value) || 0) * 100;
    // 存数字
    const onChange = (val) => {
      (listeners.change || []).forEach(fn => {
        if (val === undefined) {
          return fn(undefined);
        }
        return fn(((val || 0) / 100).toFixed(2));
      });
    }
    return <el-input-number type="text" value={percent} onChange={onChange} min={0} max={99} step={1} step-strictly />
  }
}

@Component
export default class PaymentAccounts extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {
    tax_rate: 0
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const array = [
      'name_cont',
      'code_cont',
      'state_eq',
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      'code',
      'name',
      'state',
      'position',
      {
        key: 'tax_rate',
        renderCell(h, { props: { value } }) {
          return <span>{`${value * 100}%`}</span>
        }
      },
      'remark',
      type === 'show' && 'created_at',
      type === 'show' && 'updated_at',
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource - RESTful api resoure name
   * @param {Object} params.data - current form data
   * @param {Function} params.change - invoke this method to sync form change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const array = [
      'code',
      'name',
      {
        key: 'position',
        renderCell: {
          hint: this.$t('hint.positionColumn'),
        },
      },
      {
        key: 'tax_rate',
        renderCell: {
          component: (h, context) => <TexRate {...context} />,
          hint: '百分比数字，0 - 99'
        }
      },
      'remark',
    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { reload }) {
    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'payment_accounts.edit', params: { id: row.id } }
        }
      },
      // row.can_destroy && {
      //   component: 'confirmButton',
      //   props: {
      //     label: this.$t('destroy'),
      //     type: 'danger',
      //     can: 'payment_accounts.destroy'
      //   },
      //   on: {
      //     confirm: () => remove(row.id)
      //   }
      // },
      row.state === 'inactive' && {
        component: 'confirmButton',
        props: {
          label: this.$t('actions.paymentAccount.activate'),
          type: 'primary',
          can: 'payment_accounts.update'
        },
        on: {
          confirm: async () => {
            await this.$autoLoading(this.$request.put(`/payment_accounts/${row.id}/activate`));
            this.$message.success(this.$t('operateSuccess'));
            reload();
          }
        }
      },
      row.state === 'active' && {
        component: 'confirmButton',
        props: {
          label: this.$t('actions.paymentAccount.deactivate'),
          type: 'danger',
          can: 'payment_accounts.update'
        },
        on: {
          confirm: async () => {
            await this.$autoLoading(this.$request.put(`/payment_accounts/${row.id}/deactivate`));
            this.$message.success(this.$t('operateSuccess'));
            reload();
          }
        }
      },
    ].filter(Boolean);
  }
}

export const route = [
  {
    path: '/payment_accounts',
    name: 'payment_accounts.index',
    component: PaymentAccounts,
    props: {
      type: 'index',
    }
  },
  {
    path: '/payment_accounts/new',
    name: 'payment_accounts.new',
    component: PaymentAccounts,
    props: {
      type: 'new',
    }
  },
  {
    path: '/payment_accounts/:id',
    name: 'payment_accounts.show',
    component: PaymentAccounts,
    props: {
      type: 'show',
    }
  },
  {
    path: '/payment_accounts/:id/edit',
    name: 'payment_accounts.edit',
    component: PaymentAccounts,
    props: {
      type: 'edit'
    }
  }
]
</script>
